module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "journey-chat"
  }, [_c('div', {
    ref: "messagesContainer",
    staticClass: "journey-chat-messages"
  }, [_vm._l((_vm.messages), function(msg, i) {
    return _c('div', {
      key: i,
      class: ['journey-chat-message', msg.role]
    }, [_c('div', {
      staticClass: "journey-chat-bubble"
    }, [_c('span', [_vm._v(_vm._s(msg.text))]), _vm._v(" "), (msg.hasJson) ? _c('span', {
      staticClass: "journey-chat-json-badge"
    }, [_vm._v("Journey updated")]) : _vm._e(), _vm._v(" "), (msg.debug) ? _c('span', {
      staticClass: "journey-chat-debug"
    }, [_vm._v(_vm._s(msg.debug.model) + " · " + _vm._s(msg.debug.totalTokens) + " tokens")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "journey-chat-message system"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.messages.length && !_vm.loading) ? _c('div', {
    staticClass: "journey-chat-empty"
  }, [_vm._v("\n      Describe the journey you want to build and I'll generate it for you.\n    ")]) : _vm._e()], 2), _vm._v(" "), (_vm.messages.length) ? _c('div', {
    staticClass: "journey-chat-toolbar"
  }, [_c('button', {
    staticClass: "journey-chat-clear",
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Clear")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "journey-chat-input-bar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputText),
      expression: "inputText"
    }],
    staticClass: "journey-chat-input",
    attrs: {
      "placeholder": "e.g. Build a 3-stage diabetes screening journey...",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.inputText)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.send.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "journey-chat-send",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.send
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "18",
      "height": "18",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "journey-chat-bubble journey-chat-bubble--loading"
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0566a6bf","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/JourneyChat.vue
// module id = WMLT
// module chunks = 1